// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteOwnerCorporateDataMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteOwnerCorporateDataMutationResult = { __typename?: 'Mutation', deleteOwnerCorporateData: boolean };

export const DeleteOwnerCorporateDataGql = gql`
    mutation DeleteOwnerCorporateData($id: Int!) {
  deleteOwnerCorporateData(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOwnerCorporateDataInjectable extends Apollo.Mutation<DeleteOwnerCorporateDataMutationResult, DeleteOwnerCorporateDataMutationVariables> {
    override document = DeleteOwnerCorporateDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */